import React from "react";
import IconList from "./Icon-list";
import "./Icon.css";

export const Icon = ({
  name = "loading",
  width = 10,
  height = undefined,
  alt = "icon",
  className = "",
  style = {},
  opacity = 1,
  ...props
}) => {
  const MyIcon = IconList[name];
  const styles = Object.assign({}, style, {
    width: `${width}px`,
    height: `${height}px`,
    opacity: opacity,
  });

  return (
    <div className={`Icon ${className}`} style={styles} {...props}>
      <MyIcon style={styles} />
    </div>
  );
};
